import React, { useEffect, useId, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

// Sin persistir permisos ni datos de usuario: solo el estado visual del grupo.
export default function SidebarGroup({ label, items, onNavigate }) {
  const { pathname } = useLocation();
  const id = useId();
  const active = items.some(item => pathname === item.path || pathname.startsWith(`${item.path}/`));
  const [open, setOpen] = useState(active);
  useEffect(() => { if (active) setOpen(true); }, [active, pathname]);
  if (!items.length) return null;
  return <div>
    {label && <button type="button" aria-expanded={open} aria-controls={id}
      onClick={() => setOpen(value => !value)}
      className="w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-[11px] font-bold tracking-wide hover:bg-black/5"
      style={{ color: active ? 'var(--primary)' : 'var(--text-1)' }}>
      {label}<ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
    </button>}
    <div id={id} hidden={!!label && !open} className={label ? 'pl-2 space-y-0.5' : 'space-y-0.5'}>
      {items.map(item => <NavLink key={item.path} to={item.path} onClick={onNavigate}
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        data-testid={`sidebar-nav-${item.path.replace('/', '')}`}>
        <item.icon className="w-[14px] h-[14px] flex-shrink-0" />
        <span className="text-xs">{item.label}</span>
      </NavLink>)}
    </div>
  </div>;
}
